import { useEffect } from 'react'
import { useRouter } from 'next/router'
import querystring from 'querystring'
import useStores from 'spartacus/hooks/useStores'
import Constants from 'spartacus/constants'

export default (): JSX.Element | null => {
  const router = useRouter()
  const { sessionStore } = useStores()
  const hash = router.asPath.split('?')[1] || ''
  const { token } = querystring.parse(hash)

  let decodedToken: string | undefined

  try {
    decodedToken = typeof token === 'string' ? atob(decodeURIComponent(token)) : undefined
  } catch (e) {
    // fail silently
  }

  useEffect(() => {
    sessionStore.reset()
    sessionStore.invitationToken = decodedToken
  }, [])

  if (Constants.IS_BROWSER) {
    router.replace('/')
  }

  return null
}
